import { ProductionJobStatus } from "@models/review/production-job.model";

export class ProductionJobView {
    productionJobId: string;
    caseId: string;
    createdById: string;
    runById: string;
    title: string;
    comments: string;
    dateTimeCreated: string;
    dateTimeRun: string;
    batesBasePrefix: string;
    batesBaseNumberStart: number;
    batesBaseNumberDigits: number;
    customDesignation: string;
    isBatesStampPages: boolean;
    isControlNumberStampPages: boolean;
    isCreateTiff: boolean;
    docSizeProduced: number;
    docSizeWithheld: number;
    batesRangeProduction: string;
    isImportProductionJob: boolean;
    batesRangeWithheld: string;
    lifecycle: number;
    status: ProductionJobStatus;
    isIncludeNativeEmails: boolean;
    sortId: string;
    sortLevel1: number;
    sortLevel2: number;
    level1FieldId: string;
    totalDocCount?: number;
    producedDocCount: number;
    withheldDocCount: number;
    partiallyPrivilegedDocCount: number;
}